<div class="sidebar-layout">
  <div class="sidebar-layout-header">
    <ebw-monorepo-sidebar-header [icon]="'labs'" [title]="'map.sidebar.controlli.title'" [isSvg]="false"
      [isOutline]="true" [fill]="true">
    </ebw-monorepo-sidebar-header>
  </div>

  <mat-tab-group class="sezione-tabs" animationDuration="0ms" (selectedIndexChange)="outerTabIndex = $event">
    <mat-tab label="Visualizzazione">
      <div class="parent-div mt-2">
        <ebw-monorepo-rischio-analitico [isActive]="outerTabIndex === 0"></ebw-monorepo-rischio-analitico>
      </div>
    </mat-tab>
    <mat-tab label="Caricamenti">
      <div class="parent-div mt-2">
        <mat-tab-group animationDuration="0ms">
          <mat-tab label="Controlli/Prelievi">
            <div class="mt-2">
              <ebw-monorepo-controlli-upload-sezione [type]="'prelievi'"></ebw-monorepo-controlli-upload-sezione>
            </div>
          </mat-tab>
          <mat-tab label="Superamenti Reportnet3">
            <div class="mt-2">
              <ebw-monorepo-controlli-upload-sezione [type]="'superamenti'"></ebw-monorepo-controlli-upload-sezione>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
